import { asyncLoadRouter } from '@router/helper'

const property = [
  {
    path: 'property',
    component: asyncLoadRouter('manager/machines/Property'),
    redirect: (to) => {
      return {
        name: 'manager-machines-property-edit',
        params: { machine_id: to.params.machine_id },
      }
    },
    meta: {
      breadcrumb: (i18n, params) => [
        {
          text: i18n.t('activerecord.models.machine/property.one'),
          to: {
            name: 'manager-machines-property-edit',
            params: { machine_id: params.machine_id },
          },
        },
      ],
    },
    children: [
      {
        path: 'edit',
        name: 'manager-machines-property-edit',
        component: asyncLoadRouter('manager/machines/property/Form'),
        meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.edit') }] },
        props: { action: 'update' },
      },
    ],
  },
]

export default property
